import { render, staticRenderFns } from "./fccCriarSQL.vue?vue&type=template&id=37f22bb3"
import script from "./fccCriarSQL.vue?vue&type=script&lang=js"
export * from "./fccCriarSQL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports